// extracted by mini-css-extract-plugin
export default {"form":"styles_form__GWX3q","submit":"styles_submit__Cl05W"};